export function authErrorMessage(detail) {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || 'Check your account details.').join(' ');
  return 'Unable to sign in. Please try again.';
}